import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';

const Navbar = ({ content, logo }) => {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="fixed w-full z-50 bg-white/80 backdrop-blur-md border-b border-gray-100">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <img src={logo} alt="Logo" className="h-8 w-auto" />
          </div>
          
          {/* Desktop menu */}
          <div className="hidden md:flex items-center space-x-6">
            <a href="#services" className="text-gray-700 hover:text-custom font-medium">
              {t('navigation.services')}
            </a>
            <a href="#workflow" className="text-gray-700 hover:text-custom font-medium">
              {t('navigation.workflow')}
            </a>
            <a href="#international" className="text-gray-700 hover:text-custom font-medium">
              {t('navigation.international')}
            </a>
            <a href="#projects" className="text-gray-700 hover:text-custom font-medium">
              {t('navigation.projects')}
            </a>
            <a href="#testimonials" className="text-gray-700 hover:text-custom font-medium">
              {t('navigation.testimonials')}
            </a>
            <LanguageSwitcher />
            <a 
              href="#contact" 
              className="rounded-button bg-custom text-white px-6 py-2 font-medium hover:bg-custom/90"
            >
              {t('navigation.contact')}
            </a>
          </div>
          
          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button 
              onClick={toggleMenu}
              className="text-gray-700 hover:text-custom focus:outline-none"
              aria-label="Toggle menu"
            >
              <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} className="h-6 w-6" />
            </button>
          </div>
        </div>
      </div>
      
      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-b border-gray-100 shadow-lg">
          <div className="px-4 py-3 space-y-3">
            <a 
              href="#services" 
              className="block text-gray-700 hover:text-custom font-medium py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              {t('navigation.services')}
            </a>
            <a 
              href="#workflow" 
              className="block text-gray-700 hover:text-custom font-medium py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              {t('navigation.workflow')}
            </a>
            <a 
              href="#international" 
              className="block text-gray-700 hover:text-custom font-medium py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              {t('navigation.international')}
            </a>
            <a 
              href="#projects" 
              className="block text-gray-700 hover:text-custom font-medium py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              {t('navigation.projects')}
            </a>
            <a 
              href="#testimonials" 
              className="block text-gray-700 hover:text-custom font-medium py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              {t('navigation.testimonials')}
            </a>
            <div className="py-2">
              <LanguageSwitcher />
            </div>
            <a 
              href="#contact" 
              className="block rounded-button bg-custom text-white px-6 py-2 font-medium hover:bg-custom/90 text-center"
              onClick={() => setIsMenuOpen(false)}
            >
              {t('navigation.contact')}
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
